import {atom} from 'jotai'
import {ListFilter, StatementList} from 'src/feature/statement/domain/statement'

const list: StatementList = {
  dataList: [],
}

export const listAtom = atom<StatementList>(list)
export const listFilterAtom = atom<ListFilter>({
  periodType: 1,
  periodMounth: 9,
  periodYear: 2023,
})
